import { render } from "./AppFooter.vue?vue&type=template&id=0d3c076e&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=0d3c076e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3c076e"]])

export default __exports__